<template>
  <div class="otp-wrapper">
    <label class="ml-1">{{ options.generalInfo }}</label>
    <div class="otp-inputs">
      <input v-for="(val, idx) in otp" :key="idx" ref="otpRefs" type="text" maxlength="1" class="otp-box"
        v-model="otp[idx]" :class="{ error: hasError }" @input="onInput(idx)"
        @keydown.backspace="onBackspace($event, idx)" @paste="onPaste" />
    </div>
    <span class="error-info" v-if="hasError">{{ options.errorInfo }}</span>
    <div class="resend">
      <span v-if="timer > 0">Reintentar en {{ timer }}s</span>
      <button v-else @click="resendCode">Reenviar código</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "OtpInput",
  props: {
    options: {
      type: Object,
      default: () => ({
        generalInfo: "Ingrese el código de acceso que se envió a su correo electrónico:",
        errorInfo: "El código de acceso es incorrecto",
      }),
    },
    length: {
      type: Number,
      default: 6,
    },
  },
  data() {
    return {
      otp: [],
      timer: 60,
      interval: null,
      hasError: false,
    };
  },
  mounted() {
    this.otp = Array(this.length).fill("");
    this.startTimer();
    this.$nextTick(() => {
      this.focusInput(0);
    });
  },
  methods: {
    focusInput(index) {
      if (this.$refs.otpRefs && this.$refs.otpRefs[index]) {
        this.$refs.otpRefs[index].focus();
      }
    },
    setErrorState() {
      this.hasError = true;
      this.otp = Array(this.length).fill("");

      this.$nextTick(() => {
        this.focusInput(0);
      });
    },
    onInput(index) {
      this.hasError = false;

      const value = this.otp[index].replace(/\D/g, "").charAt(0) || "";
      this.$set(this.otp, index, value);

      if (value && index < this.length - 1) {
        this.$refs.otpRefs[index + 1]?.focus();
      }

      if (this.otp.every((char) => char !== "")) {
        this.$nextTick(() => {
          this.$emit("complete", this.otp.join(""));
        });
      }
    },
    onBackspace(event, index) {
      event.preventDefault();
      if (this.otp[index]) {
        this.$set(this.otp, index, "");
      } else if (index > 0) {
        this.$set(this.otp, index - 1, "");
        this.$nextTick(() => {
          this.focusInput(index - 1);
        });
      }
    },
    onPaste(e) {
      e.preventDefault();
      this.hasError = false;
      const paste = e.clipboardData.getData("text").replace(/\D/g, "").slice(0, this.length);
      const chars = paste.split("");

      for (let i = 0; i < this.length; i++) {
        this.$set(this.otp, i, chars[i] || "");
      }

      this.$nextTick(() => {
        const nextIndex = this.otp.findIndex((c) => c === "");
        if (nextIndex >= 0) {
          this.focusInput(nextIndex);
        } else {
          this.focusInput(this.length - 1);
          setTimeout(() => {
            this.$emit("complete", this.otp.join(""));
          }, 50);
        }
      });
    },
    startTimer() {
      this.timer = 60;
      clearInterval(this.interval);
      this.interval = setInterval(() => {
        this.timer--;
        if (this.timer <= 0) {
          clearInterval(this.interval);
        }
      }, 1000);
    },
    resendCode() {
      this.otp = Array(this.length).fill("");
      this.$nextTick(() => {
        this.focusInput(0);
      });
      this.startTimer();
      this.$emit("resend");
    },
  },
};
</script>

<style scoped>
.otp-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.otp-inputs {
  display: flex;
  gap: 0.5rem;
}

.otp-box {
  width: 3rem;
  height: 3rem;
  font-size: 1.5rem;
  text-align: center;
  border: 1px solid #ccc;
  border-radius: 0.5rem;
  outline: none;
  transition: all 0.2s ease;
  background-color: #f1f1f1;
  color: #000;
}

.otp-box:focus {
  border-color: #1A5CFF;
  box-shadow: 0 0 0 2px rgba(26, 92, 255, 0.2);
}

.otp-box.error {
  border-color: #dc3545 !important;
  box-shadow: 0 0 0 2px rgba(220, 53, 69, 0.25);
}

.error-info {
  color: #dc3545;
  font-size: 0.9rem;
  margin-top: 0.5rem;
}

.dark .otp-box {
  background-color: #18191c;
  border: 1px solid #444;
  color: #fff;
}

.resend {
  margin-top: 1rem;
  font-size: 0.9rem;
  color: #555;
}

.dark .resend {
  color: #ccc;
}

.resend button {
  background: none;
  border: none;
  color: #4677d5;
  cursor: pointer;
  text-decoration: underline;
}
</style>
